import React, { Component } from "react";
import "./NodeModal.css";
import InfoIcon from './InfoIcon'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

export default class OrganizationAddModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationUUID: "",
      validationError: [],
      isValid: true,
    };
  }

  validateInput = () => {
    let errors = [];
    if (
      /^(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/.test(
        this.state.organizationUUID
      )
    ) {
      this.setState({ isValid: true, validationErrors: [] });
      return true;
    }
    errors.push(<li key={"email"}>UUID entered is not valid</li>);
    this.setState({ isValid: false, validationErrors: errors });
    return false;
  };

  handleChange = (e) => {
    let uuid = e.target.value;
    this.setState({ organizationUUID: uuid });
  };

  render() {
    const { toggle, toggleName, getErrors, onSave } = this.props;

    return (
      <Modal modalClassName="Modal" isOpen={true} toggle={function(){ return toggle(toggleName);}}>
        <ModalHeader>
          Add organization
          <button className="exit_close_button" onClick={function(){ return toggle(toggleName)}}>
            ×
          </button>
        </ModalHeader>

        <div className="val_error_area">
          <ul style={{ color: "red" }}>
            {this.state.isValid ? getErrors() : this.state.validationErrors}
          </ul>
        </div>
        <ModalBody>
          <Form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <FormGroup className="fg">
              <Label for="eid">Enter organization UUID</Label>
              <InfoIcon position="right" infoText="A member of the organization you wish to add can provide this UUID token."/>
              <Input
                type="text"
                name="organizationUUID"
                value={this.state.organizationUUID}
                onChange={this.handleChange}
                placeholder="Example: 63fc7e22-b2c3-413c-89c0-7cf4692a2ac2"
                maxLength="36"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <button
            className="save_button"
            color="success"
            onClick={() => {
              if (this.validateInput()) {
                onSave(this.state.organizationUUID);
              }
            }}
          >
            Add organization
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
